
import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import user from "../assets/img/user.png";
import calenders from "../assets/img/.png";
import API from './Services/Baseservice';
import comments1 from "../assets/img/-1.png";
import ClipLoader from "react-spinners/ClipLoader";
import SharePopup from "../pages/sharepopup";
import { LanguageContext } from '../pages/languagecontext';
import SEO from "../pages/SEO";
import { getPageSEO } from "../pages/SEOblogConfig";
const BlogDetails = () => {
  const location = useLocation();
  const { id } = useParams();
  const { slug } = useParams();
  const blogId = location.state?.id;
  const { selectedLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState("");
  const [currentBlog, setCurrentBlog] = useState(null);
  const [comments, setComments] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [leavecomments, setLeaveCommets] = useState("");
  const [showButtons, setShowButtons] = useState(true);
  const commentsRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [specialbloglist, setSpecialBloglist] = useState([])
  const [allBlogs, setAllBlogs] = useState([]);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const createSlug = (text) => {
    return text
      ?.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");
  };
  useEffect(() => {
    if (slug && selectedLanguage?.id) {
      fetchBlogBySlug(slug);
    }
  }, [slug, selectedLanguage?.id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const fetchBlogBySlug = async (slug) => {
    setLoading(true);
    try {
      // First, fetch all blogs to find the one with matching slug
      const req = {
        page: 1,
        rowsPerPage: 100, // Fetch enough blogs
        language_id: selectedLanguage.id,
      };

      const response = await API.post("webblog_list/webCondition", req);

      if (response.data.data.success === true) {
        const blogs = response.data.data.data || [];
        setAllBlogs(blogs);

        // Find blog with matching slug
        const foundBlog = blogs.find(blog => {
          const blogSlug = createSlug(blog.heading);
          return blogSlug === slug;
        });

        if (foundBlog) {
          // Fetch full details of the found blog
          await fetchBlogDetails(foundBlog.blog_id);
        } else {
          // Blog not found
          setLoading(false);
          setCurrentBlog(null);
        }
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (blogId) {
      fetchBlogDetails(blogId);
    }
  }, [blogId]);
  // useEffect(() => {

  //   listforblog();
  // }, [])
  // const listforblog = () => {
  //   let req = {
  //     page: "",
  //     rowsPerPage: "",
  //     language_id: selectedLanguage.id

  //   }
  //   API.post("webblog_list/webCondition", req).then((response) => {
  //     if (response.data.data.success === true) {
  //       setSpecialBloglist(response.data.data.data);
  //     }
  //   });
  // }
  useEffect(() => {
    const handleVisibility = () => {
      if (!commentsRef.current) {
        setShowButtons(true);
        return;
      }

      const rect = commentsRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const offset = 0.25 * viewportHeight;
      const commentsVisible = rect.top <= viewportHeight - offset && rect.bottom >= 0;
      setShowButtons(!commentsVisible);
    };
    handleVisibility();
    const timeout = setTimeout(handleVisibility, 500);
    window.addEventListener("scroll", handleVisibility, { passive: true });
    window.addEventListener("resize", handleVisibility);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("scroll", handleVisibility);
      window.removeEventListener("resize", handleVisibility);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (specialbloglist.length > 0 && id) {
      const foundIndex = specialbloglist.findIndex(
        blog => String(blog.blog_id) === String(id)
      );

      setCurrentIndex(foundIndex !== -1 ? foundIndex : 0);
    }
  }, [specialbloglist, id]);



  useEffect(() => {
    if (id) {
      fetchBlogDetails(id);
    }
  }, [id]);

  const fetchBlogDetails = async (blogId) => {
    try {
      const req = { blog_id: blogId };
      const response = await API.post("webBlog_view/webCondition", req);
      if (response.data.success) {
        setCurrentBlog(response.data.data);
        setComments(response.data.data.comments || []);
        setLoading(false);
      } else {
        console.error("Failed to fetch blog:", response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching blog details:", error);
      setLoading(false);
    }
  };


  const handlePrev = () => {
    if (!allBlogs.length) return;
    const currentIndex = allBlogs.findIndex(blog => blog.blog_id === currentBlog?.blog_id);
    if (currentIndex === -1) return;

    const prevIndex = currentIndex > 0 ? currentIndex - 1 : allBlogs.length - 1;
    const prevBlog = allBlogs[prevIndex];
    if (prevBlog) {
      navigate(`/${createSlug(prevBlog.heading)}`);
    }
  };

  const handleNext = () => {
    if (!allBlogs.length) return;
    const currentIndex = allBlogs.findIndex(blog => blog.blog_id === currentBlog?.blog_id);
    if (currentIndex === -1) return;

    const nextIndex = currentIndex < allBlogs.length - 1 ? currentIndex + 1 : 0;
    const nextBlog = allBlogs[nextIndex];
    if (nextBlog) {
      navigate(`/${createSlug(nextBlog.heading)}`);
    }
  };



  const add = (e) => {
    e.preventDefault();
    let req = {
      language_id: 1,
      blog_id: currentBlog.blog_id,
      user_name: name,
      email: email,
      comments: leavecomments,
      createdBy: name,
      updatedBy: name
    };

    API.post("webAdd_blogcomments/add1", req).then((response) => {
      if (response.data.success === true) {
        fetchBlogDetails(currentBlog.blog_id)
      } else {
        console.error("Failed to add comment:", response.data);
      }
    }).catch((error) => {
      console.error("Error posting comment:", error);
    });
  };
  const [showPopup, setShowPopup] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const shareUrl = window.location.href;
  const shareText = `Check out this blog: ${currentBlog?.heading || ""}`;

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://platform-api.sharethis.com/js/sharethis.js#property=YOUR_PROPERTY_KEY&product=inline-share-buttons";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (window.__sharethis__) {
        window.__sharethis__.initialize();
      }
    };
  }, []);

  // useEffect(() => {
  //   if (currentBlog && currentBlog.heading) {
  //     document.title = currentBlog.heading;
  //   }
  // }, [currentBlog]);

  const handleShareClick = () => {
    const text = currentBlog?.heading
      ? `Check out this blog: ${currentBlog.heading}`
      : "";
    navigator.clipboard.writeText(text)
      .catch(() => console.log("Clipboard failed"));
    setShowPopup(true);
  };
  const cleanHTML = (html = "") =>
    html.replace(/(width|height)="[^"]*"/gi, "").replace(/style="[^"]*"/gi, "");
  const stripHTML = (html = "") =>
    html
      .replace(/<[^>]*>?/gm, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const blogSEO = currentBlog
    ? getPageSEO(currentBlog.blog_id, createSlug(currentBlog.heading), selectedLanguage?.id)
    : null;
  console.log("blog_id:", currentBlog?.blog_id, typeof currentBlog?.blog_id);
  console.log("blogSEO:", blogSEO);


  const seoTitle = blogSEO?.title || currentBlog?.heading || "Canadian immigration services | Immigration consultant Canada";
  const seoDescription = blogSEO?.description
    || (currentBlog?.description
      ? stripHTML(currentBlog.description).substring(0, 160)
      : "ASRA Migration provides trusted Canadian immigration services, guiding students, workers, and families with transparent advice and end-to-end support.");
  const seoKeywords = blogSEO?.keywords
    || (Array.isArray(currentBlog?.blog_tags) ? currentBlog.blog_tags.join(", ") : "");
  const seoCanonical = blogSEO?.canonical
    || `https://asraimmigration.ca/${slug || createSlug(currentBlog?.heading)}`;
  return (
    <div style={{ overflowX: 'hidden' }}>
      <SEO
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        canonical={seoCanonical}
      />
      {loading ? (
        <div className="d-flex justify-content-center mt-5 align-items-center p-5" style={{ height: "100vh" }}>
          <ClipLoader color="#36d7b7" size={50} />
        </div>
      ) : (<>
        <div className="resources asra">
          <div className=" blogsseperatepage">

            {currentBlog ? (
              <>
                <div className="container">
                  <div className="position-relative">
                    <h3>{currentBlog.heading}</h3>
                    <div
                      className="d-flex align-items-center w-100 mt-3"
                      style={{ justifyContent: "space-between" }}
                    >

                      <div className="d-flex align-items-center gap-4 flex-wrap">
                        <div className="d-flex align-items-center gap-2">
                          <img src={user} className="usericon" alt="user" />
                          <p className="mb-0 byadmin">{currentBlog.author_name}</p>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          <img src={calenders} className="calendericon" alt="calendar" />
                          <p className="mb-0 byadmin">{currentBlog.blog_date}</p>
                        </div>
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            commentsRef.current?.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            })
                          }
                        >
                          <img src={comments1} className="calendericon" alt="comments" />
                          <p className="mb-0 byadmin"> {selectedLanguage.id === 1 ? 'Comments' : 'Commentaires'}({comments.length})</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          onClick={handleShareClick}
                          className="btn btnredcolour d-flex align-items-center gap-2"
                        >
                          <i className="fa-solid fa-share-nodes"></i>
                          {selectedLanguage.id === 1 ? 'Share' : 'Partager'}
                        </button>

                        {showPopup && currentBlog && (
                          <SharePopup
                            shareUrl={window.location.href}
                            shareText={`Check out this blog: ${currentBlog?.heading || ""}`}
                            heading={currentBlog.heading}
                            data={currentBlog}
                            id={currentBlog.blog_id}
                            onClose={() => setShowPopup(false)}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="blog-section">
                  <div className="d-flex justify-content-center align-items-center mt-3" style={{ position: "relative" }}>
                    {showButtons && (
                      <button
                        type="button"
                        className="btn prevredcolour rounded-pill px-4  prevbutton"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePrev();
                        }}
                        disabled={currentIndex === 0}
                        style={{ cursor: currentIndex === 0 ? "not-allowed" : "pointer" }}
                      >
                        <i className="bi bi-chevron-left" style={{ fontSize: "20px", color: "white" }}></i>
                      </button>)}
                    <div className="text-center">
                      <img
                        key={currentBlog.blog_image}
                        src={currentBlog.blog_image}
                        alt="Blog"
                        className="faqimage fade-image"
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    {showButtons && (
                      <button
                        type="button"
                        className="btn prevredcolour rounded-pill px-4  nextbutton"
                        onClick={(e) => {
                          e.preventDefault();
                          handleNext();
                        }}
                        disabled={currentIndex === specialbloglist.length - 1}
                        style={{
                          cursor:
                            currentIndex === specialbloglist.length - 1
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <i
                          className="bi bi-chevron-right"
                          style={{ fontSize: "20px", color: "white" }}
                        ></i>
                      </button>
                    )}
                  </div>

                  <div className="container col-lg-12">
                    <div className="layerone">
                      <p
                        className="aliquam mt-5"
                        dangerouslySetInnerHTML={{
                          __html: cleanHTML(currentBlog.description),
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-5 alignitemandjustfy latestnewscontents" ref={commentsRef}>
                  <div className="container col-lg-12 comments-section "
                    style={{ minHeight: "400px", marginTop: "50px" }}>
                    <div className="shadow-sm p-3 bg-white rounded col-lg-6 d-block mx-auto">
                      <div className="shadow-sm p-3  steelblue rounded col-lg-12">
                        <h2 className="leaveacooment">{selectedLanguage.id === 1 ? 'Leave a Comment' : 'Laissez un commentaire'}</h2>
                        <div class="row mb-3 mt-3">
                          <div class="col-12 col-md-6">
                            <label className="labelnamesblog">{selectedLanguage.id === 1 ? 'Name' : 'Nom'}</label>
                            <input type="text" class="form-control typeyourtext" placeholder={selectedLanguage.id === 1 ? "Type your Name" : "Tapez votre nom"} value={name} onChange={(e) => setName(e.target.value)} />
                          </div>
                          <div class="col-12 col-md-6">
                            <label className="labelnamesblog">{selectedLanguage.id === 1 ? 'Email Address' : 'Adresse e-mail'}</label>
                            <input type="text" class="form-control typeyourtext" placeholder={selectedLanguage.id === 1 ? "Type Your Email Address" : "Tapez votre adresse e-mail"} value={email} onChange={(e) => setEmail(e.target.value)} />
                          </div>
                        </div>
                        <div class="col mt-3">
                          <label className="labelnamesblog">{selectedLanguage.id === 1 ? 'Leave a Comment' : 'Laissez un commentaire'}</label>
                          <textarea type="text" class="form-control typeyourtext" placeholder={selectedLanguage.id === 1 ? "Type Your comments here" : "Tapez vos commentaires ici"} value={leavecomments} onChange={(e) => setLeaveCommets(e.target.value)} rows={5} />
                        </div>
                        <div className="d-flex justify-content-end">
                          <div className="steelblue rounded d-flex gap-2 mt-3">
                            <button
                              className="btn prevredcolour"
                              onClick={add}
                              style={{ cursor: "pointer" }}
                            >
                              {selectedLanguage.id === 1 ? 'Post' : 'Publication'}  <i className="bi bi-arrow-right arrowbold"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div
                          className="shadow-sm p-4  rounded commentslist"
                          style={{
                            maxHeight: "400px",
                            overflowY: "auto",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <h5 className="mb-3">{selectedLanguage.id === 1 ? 'Comments' : 'Commentaires'} ({comments.length})</h5>
                          {comments.length > 0 ? (
                            comments.map((item, index) => (
                              <div
                                key={index}
                                className="mb-3 p-3 rounded"
                                style={{
                                  backgroundColor: "#ffffff",
                                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                }}
                              >
                                <p className="commentsp mb-1" style={{ fontWeight: "600", color: "#343a40" }}>
                                  {item.user_name}
                                </p>
                                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                  {item.comments}
                                </p>
                              </div>
                            ))
                          ) : (
                            <p className="text-secondary">{selectedLanguage.id === 1 ? 'No comments yet.' : 'Aucun commentaire pour le moment'}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <p className="text-center mt-5 text-muted">No Data Found</p>
            )}
          </div>
        </div>

        {showScrollTop && (
          <button
            className="scroll-top-btn"
            aria-label="Scroll to top"
            onClick={scrollToTop}
          >
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="19" x2="12" y2="5"></line>
              <polyline points="5 12 12 5 19 12"></polyline>
            </svg>
          </button>
        )}
      </>)}
    </div>
  );
};
export default BlogDetails;
